import type React from "react";

import { backgroundTaskIsRunning } from "./BackendClientLegacy";

export type BackgroundTask = {
  isRunning: boolean;
  message?: string | null;
  lastRunSuccessful?: boolean;
};

export type InfoAlert = {
  message?: string | null;
  level: "info";
};

export async function waitForTaskToFinish<TState extends { loading?: boolean; alert?: unknown }>(
  pollingEndpoint: string,
  setState: React.Dispatch<React.SetStateAction<TState>>,
): Promise<BackgroundTask | undefined> {
  let backgroundTask = await backgroundTaskIsRunning(pollingEndpoint);

  const wasRunningInTheBeginning = Boolean(backgroundTask?.isRunning);

  while (backgroundTask.isRunning) {
    await new Promise<void>((resolve) => {
      setTimeout(resolve, 1000);
    });

    backgroundTask = await backgroundTaskIsRunning(pollingEndpoint);

    setState((prev) => ({
      ...prev,
      loading: true,
      alert: {
        message: backgroundTask?.message ?? undefined,
        level: "info",
      } as InfoAlert,
    }));
  }

  if (wasRunningInTheBeginning) {
    return backgroundTask;
  }

  return undefined;
}
